import { get, isEmpty } from 'lodash-es';

const normalizeVsGamesFromCms = (games) => {
  const normalizedVsGames = {};
  const ids = [];

  for (const [key, game] of Object.entries(games)) {
    const {
      gameId,
      supportDemo: hasDemoSupport,
      providerId,
      launchGameId
    } = game;

    const lobbyImage =
      game.desktop?.gameImage ||
      game.tablet?.gameImage ||
      game.mobile?.gameImage;

    normalizedVsGames[key] = {
      ...game,
      gameCode: gameId,
      launchGameId,
      hasDemoSupport,
      provider: providerId,
      categoryName: game.gameName,
      categoryId: gameId,
      isFrame: true,
      lobbyImage
    };

    ids.push(key);
  }

  return { data: normalizedVsGames, ids, isLoaded: true };
};

const normalizeVsCategoriesFromCms = (categories, content, normalizedGames) =>
  categories.reduce(
    (acc, categoryId) => {
      const item = content[categoryId];

      if (isEmpty(item) || item.games.length === 0) {
        return acc;
      }

      const filteredGames = item.games.filter(
        (gameId) => normalizedGames.data[gameId]
      );

      if (filteredGames.length === 0) {
        return acc;
      }

      const { name } = item;

      return {
        ...acc,
        data: Object.assign(acc.data, {
          [name]: {
            id: name,
            ...item.settings,
            games: filteredGames
          }
        }),
        ids: [...acc.ids, name],
        isLoaded: true
      };
    },
    { data: {}, ids: [], isLoaded: true }
  );

export const normalizeVsProvidersFromCms = (
  providersKeys,
  content,
  providers,
  normalizedGames
) => {
  const normalizedContentProviders = providersKeys.reduce(
    (acc, key) => {
      const item = content[key];
      const provider = providers[item.name] || {};

      if (isEmpty(provider) || item.games.length === 0) {
        return acc;
      }

      const filteredGames = item.games.filter(
        (gameId) => normalizedGames.data[gameId]
      );

      if (filteredGames.length === 0) {
        return acc;
      }

      return {
        data: Object.assign(acc.data, {
          [provider.providerId]: Object.assign(item, provider, {
            games: filteredGames,
            name: item.name,
            categoryName: provider.providerName,
            categoryId: provider.providerId,
            isFrame: true
          })
        }),
        ids: [...acc.ids, provider.providerId]
      };
    },
    { data: {}, ids: [] }
  );

  return {
    ...normalizedContentProviders,
    data: {
      ...providers,
      ...normalizedContentProviders.data
    },
    isLoaded: true
  };
};

export const parseVsGamesFeed = ({ data, feedName }) => {
  const gamesFeed = data?.feeds.find((feed) => feed.feedName === feedName);
  const actualGamesFeed = gamesFeed || {
    ...(get(data, 'feeds[0]') || {}),
    categories: get(data, 'feeds[0].categories') || [],
    providers: get(data, 'feeds[0].providers') || [],
    content: get(data, 'feeds[0].content') || {}
  };
  const normalizedGames = normalizeVsGamesFromCms(data.games);

  return {
    feedName: actualGamesFeed.feedName,
    categories: normalizeVsCategoriesFromCms(
      actualGamesFeed.categories,
      actualGamesFeed.content,
      normalizedGames
    ),
    providers: normalizeVsProvidersFromCms(
      actualGamesFeed.providers,
      actualGamesFeed.content,
      data.providers,
      normalizedGames
    ),
    games: normalizedGames
  };
};
